export default __webpack_public_path__ + "static/media/spr-lesson-builder-light.529a5845.jpg";